/**
 * RegistrationWindow — when you can enter, how many can, and on what terms.
 *
 * Drawn twice on purpose: the rail carries it on a desktop, and the
 * Registration section carries it on a phone where the rail stands down. One
 * component so the two can never drift apart — which they did in the template,
 * where the same three rows were written out by hand in both places.
 *
 * The rows past Places are conditional, because an event that declares no
 * registration type should not show a blank row saying so. The two dates and
 * Places always show: their absence is itself worth seeing, since they are what
 * a visitor came to check.
 */

import React from 'react';

export default function RegistrationWindow({
  opensAt, closesAt, places, registrationType, registrationRequired, externalUrl,
}) {
  return (
    <div className="evb-dl">
      {/* "Registration opens", not "Opens" — the event has its own start date
          in the facts strip, and the two pairs sit a screen apart. */}
      <div><span>Registration opens</span><b>{opensAt}</b></div>
      <div><span>Registration closes</span><b>{closesAt}</b></div>
      <div><span>Places</span><b>{places}</b></div>

      {registrationType && (
        <div><span>Type</span><b>{registrationType}</b></div>
      )}

      {/* Only the surprising answer earns a row. Nearly every event requires
          registration, so saying so each time is noise — but an event you can
          simply turn up to is something a visitor needs told. */}
      {registrationRequired === false && (
        <div><span>Registration</span><b>Not required — just turn up</b></div>
      )}

      {externalUrl && (
        <div>
          <span>Entries taken on</span>
          <b>
            <a className="evb-extlink" href={externalUrl} target="_blank" rel="noopener noreferrer">
              the organiser’s site
            </a>
          </b>
        </div>
      )}
    </div>
  );
}
